export const questionValidation = (
  questionType: string,
  value: string | number | (string | number)[],
  currentUploadCount: number,
  minimumUploads: number,
  maximumUploads: number
): Promise<void> => {
  // Attachment validation
  if (questionType === 'attachment') {
    if (
      currentUploadCount >= minimumUploads &&
      currentUploadCount <= maximumUploads
    ) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  }
  // Free text, single-choice and multiple-choice validation
  if (!value || (Array.isArray(value) && !value?.length)) {
    return Promise.reject();
  }
  return Promise.resolve();
};
